import React from 'react'
import PropTypes from 'prop-types'
import { getContext, withContext, compose, withState, withHandlers } from 'recompose';
import { Portal } from 'react-portal';
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { FormattedMessage } from 'react-intl'

const Fade = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={1000}
    classNames="fade"
  >
    {children}
  </CSSTransition>
);

export const AlertProvider = compose(
  withState('alerts', 'setAlerts', []),
  withHandlers({
    success: ({ setAlerts, alerts }) => (message) => setAlerts(alerts.concat({ id: (+ new Date()), message, type: 'success' })),
    error: ({ setAlerts, alerts }) => (message) => setAlerts(alerts.concat({ id: (+ new Date()), message, type: 'error' })),
    dismiss: ({ setAlerts, alerts }) => (id) => setAlerts(alerts.filter(alert => alert.id !== id)),
  }),
  withContext(
    {
      alert: PropTypes.object.isRequired,
    },
    (props) => {
      return {
        alert: {
          success: props.success,
          error: props.error
        }
      }
    }
  )
)(({ children, alerts, dismiss }) => (
  <div>
    {children}
    <Portal>
      <TransitionGroup className="alerts">
        {
          alerts.map(alert => (
            <Fade key={alert.id}>
              <div className="alerts__item">
                <div className={`alerts__item__inner alerts__item__inner--${alert.type}`}>
                  <FormattedMessage id={alert.message} />
                  <button className="alerts__item__close" onClick={() => dismiss(alert.id)}>
                    <FormattedMessage id="flash.dismiss" />
                  </button>
                </div>
              </div>
            </Fade>
          ))
        }
      </TransitionGroup>
    </Portal>
  </div>
))

export const withAlert = getContext({
  alert: PropTypes.object.isRequired,
});



// WEBPACK FOOTER //
// ./src/components/Alert.js